import { get } from 'lodash';
import { UserSettingsEnum } from '../helpers/helper';

const root = state => get(state, 'UserSettingsState');

export const getUserSetting = (state, userSettingsEnum) => {
  return get(root(state), [
    state.SecurityState.userInfo.userName,
    userSettingsEnum,
  ]);
};

export const getTableStates = state => {
  return getUserSetting(state, UserSettingsEnum.REACT_TABLES);
};

export const getPosServingMenusUserSettings = state => {
  return getUserSetting(state, UserSettingsEnum.POS_SERVING_MENUS);
};

export const getPosServingOptionsUserSettings = state => {
  return getUserSetting(state, UserSettingsEnum.POS_SERVING_OPTIONS);
};

export const getMnuEditMenuUserSettings = state => {
  return getUserSetting(state, UserSettingsEnum.MNU_EDIT_MENU);
};



// WEBPACK FOOTER //
// ./src/common/UserSettings/state/selectors.js